import React, { useRef, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Modal.css';
import Card from '../Card/Card.js';
import { Copy } from 'lucide-react';

const Modal = () => {
  useEffect(() => {

  }, []);


  // Small Modal 
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);
  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };


  // Medium Modal 
  const mDsnippetContainerRef = useRef(null);
  const [mDshowScanning, mDsetShowScanning] = useState(false);
  const mDcopySnippet = () => {
    if (mDsnippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(mDsnippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      mDsetShowScanning(true);
      setTimeout(() => mDsetShowScanning(false), 1000);
    }
  };


  // Large Modal 
  const lGsnippetContainerRef = useRef(null);
  const [lGshowScanning, lGsetShowScanning] = useState(false);
  const lGcopySnippet = () => {
    if (lGsnippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(lGsnippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      lGsetShowScanning(true);
      setTimeout(() => lGsetShowScanning(false), 1000);
    }
  };

  const openModal = (modalId) => {
    const modal = document.getElementById(modalId);
    modal.classList.add('seek');
    document.body.classList.add('freeze');
  };
  const closeModal = (modalId) => {
    const modal = document.getElementById(modalId);
    const modalChild = modal.children[0];

    modalChild.classList.add('modal-cl');
    modal.classList.add('waneout');

    setTimeout(() => {
      modal.classList.remove('seek');
      modalChild.classList.remove('modal-cl');
      modal.classList.remove('waneout');
      document.body.classList.remove('freeze');
    }, 290);
  };


  return (
    <motion.div initial={{ y: 10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -10, opacity: 0 }} transition={{ duration: 0.2 }}
    >
      <div className=''>

        {/* Small Modal  */}
        <section className='carve-space-bottom-hefty'>
          <button className="carve-button-main" onClick={() => openModal('modalSm')}>Open Modal</button>
          <div className="carve-modal" id="modalSm">
            <div className="carve-modal-inner">
              <div className="carve-modal-head">
                <div className="heading-medium">modal header</div>
              </div>
              <div className="carve-modal-body">
                <p> Lorem ipsum dolor, sit amet consectetur adipiscing elit. Dolore quod maxime
                  illo, veritatis ea quisquam voluptate. Corrupti, nisi reprehenderit rem dolorem
                  rerum nulla obcaecati, quidem, deleniti deserunt itaque odit officia!
                </p>
              </div>
              <div className="carve-modal-footer">
                <div className="button-group">
                  <button className="carve-button-vice carve-button-block">save</button>
                  <button className="carve-button-main carve-button-block" onClick={() => closeModal('modalSm')}>cancel</button>
                </div>
              </div>
            </div>
          </div>
          <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

            <div className='snippet' ref={snippetContainerRef}>

              <pre>
                <code>
                  <span className="cn">&lt;button</span>
                  <span className="cln"> class="</span><span className="cn">carve-button-main</span><span className="cln">"</span><br />
                  &nbsp;&nbsp;<span className="cln"> data-modal="</span><span className="cn">modalSm</span><span className="cln">"</span><br />
                  &nbsp;&nbsp;<span className="cln"> onclick="</span>
                  <span className="cn">openModal('modalSm')</span>
                  <span className="cln">"</span><span className="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;Open Modal<br />
                  <span className="cn">&lt;/button&gt;</span><br />
                  <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal</span><span class="cln">"</span><span class="cn"> id="modalSm"&gt;</span><br />
                  &nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal-inner</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal-head</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">heading-medium</span><span class="cln">"</span><span class="cn">&gt;</span>card header<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal-body</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Lorem ipsum dolor, sit amet consectetur adipiscing elit. Dolore quod maxime illo, veritatis ea quisquam voluptate. Corrupti, nisi reprehenderit rem dolorem rerum nulla obcaecati, quidem, deleniti deserunt itaque odit officia!<br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal-footer</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">button-group</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;button</span><span class="cln"> class="</span><span class="cn">button-vice button-block</span><span class="cln">"</span><span class="cn">&gt;</span>save<span class="cn">&lt;/button&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;button</span>
                  <span className="cln"> class="</span><span className="cn">carve-button-main carve-button-block</span><span className="cln">"</span><br />

                  &nbsp;&nbsp;<span className="cln"> data-modal="</span><span className="cn">modalSm</span><span className="cln">"</span><br />

                  &nbsp;&nbsp;<span className="cln"> onclick="</span>
                  <span className="cn">closeModal('modalSm')</span>
                  <span className="cln">"</span><span className="cn">&gt;</span><br />

                  &nbsp;&nbsp;&nbsp;&nbsp;cancel<br />

                  <span className="cn">&lt;/button&gt;</span><br />

                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  <span class="cn">&lt;/div&gt;</span><br />

                </code>
              </pre>
            </div>
            <button aria-label="Copy Button" onClick={copySnippet}>
              <Copy />
            </button>

          </div>
        </section>

        {/* Medium modal  */}
        <section className='carve-space-bottom-hefty'>
          <button className="carve-button-stroke stroke-main" onClick={() => openModal('modalMd')}>Open Medium Modal</button>
          <div className="carve-modal modal-medium" id="modalMd">
            <div className="carve-modal-inner">
              <div className="carve-modal-head">
                <div className="heading-medium">modal medium header</div>
              </div>
              <div className="carve-modal-body">
                <p> Lorem ipsum dolor, sit amet consectetur adipiscing elit. Dolore quod maxime
                  illo, veritatis ea quisquam voluptate. Corrupti, nisi reprehenderit rem dolorem
                  rerum nulla obcaecati, quidem, deleniti deserunt itaque odit officia!
                </p>
              </div>
              <div className="carve-modal-footer">
                <div className="button-group">
                  <button className="carve-button-vice carve-button-block">save</button>
                  <button className="carve-button-main carve-button-block" onClick={() => closeModal('modalMd')}>cancel</button>
                </div>
              </div>
            </div>
          </div>
          <div className={`center-container ${mDshowScanning ? 'scanning' : ''}`}>

            <div className='snippet' ref={mDsnippetContainerRef}>
              <pre>
                <code>
                  <span className="cn">&lt;button</span>
                  <span className="cln"> class="</span><span className="cn">carve-button-stroke stroke-main</span><span className="cln">"</span><br />

                  &nbsp;&nbsp;<span className="cln"> data-modal="</span><span className="cn">modalMd</span><span className="cln">"</span><br />

                  &nbsp;&nbsp;<span className="cln"> onclick="</span>
                  <span className="cn">openModal('modalMd')</span>
                  <span className="cln">"</span><span className="cn">&gt;</span><br />

                  &nbsp;&nbsp;&nbsp;&nbsp;Open Medium Modal<br />

                  <span className="cn">&lt;/button&gt;</span><br />

                  <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal modal-medium</span><span class="cln">"</span><span class="cn"> id="modalMd"&gt;</span><br />
                  &nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal-inner</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal-head</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">heading-medium</span><span class="cln">"</span><span class="cn">&gt;</span>card header<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal-body</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Lorem ipsum dolor, sit amet consectetur adipiscing elit. Dolore quod maxime illo, veritatis ea quisquam voluptate. Corrupti, nisi reprehenderit rem dolorem rerum nulla obcaecati, quidem, deleniti deserunt itaque odit officia!<br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal-footer</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">button-group</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;button</span><span class="cln"> class="</span><span class="cn">carve-button-vice carve-button-block</span><span class="cln">"</span><span class="cn">&gt;</span>save<span class="cn">&lt;/button&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;button</span>
                  <span className="cln"> class="</span><span className="cn">carve-button-main carve-button-block</span><span className="cln">"</span><br />

                  &nbsp;&nbsp;<span className="cln"> data-modal="</span><span className="cn">modalMd</span><span className="cln">"</span><br />

                  &nbsp;&nbsp;<span className="cln"> onclick="</span>
                  <span className="cn">closeModal('modalMd')</span>
                  <span className="cln">"</span><span className="cn">&gt;</span><br />

                  &nbsp;&nbsp;&nbsp;&nbsp;cancel<br />

                  <span className="cn">&lt;/button&gt;</span><br />

                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  <span class="cn">&lt;/div&gt;</span><br />

                </code>
              </pre>
            </div>
            <button aria-label="Copy Button" onClick={mDcopySnippet}>
              <Copy />
            </button>

          </div>
        </section>

        {/* Large Modal  */}
        <section className='carve-space-bottom-hefty'>
          <button className="carve-button-vice" onClick={() => openModal('modalLg')}>Open Large Modal</button>
          <div className="carve-modal split modal-large" id="modalLg">
            <div className="carve-modal-inner">
              <div className="carve-modal-head">
                <div className="heading-medium">large modal header</div>
              </div>
              <div className="carve-modal-body">
                <div className="input-field">
                  <input type="text" required="" id="value34" />
                  <label htmlFor="value34">Enter the value</label>
                </div>
                <div className="input-field mandate">
                  <input type="text" required="" id="value5" />
                  <label htmlFor="value5">Enter the value</label>
                </div>
                <div className="input-field baseline">
                  <input type="text" required="" id="value36" />
                  <label htmlFor="value36">Enter the value</label>
                </div>
                <p>Lorem ipsum dolor, sit amet consectetur adipiscing elit. Dolore quod maxime illo,
                  veritatis ea quisquam voluptate. Corrupti, nisi reprehenderit rem dolorem rerum
                  nulla obcaecati, quidem, deleniti deserunt itaque odit officia!
                </p>
                <div className="bottom-line"></div>
                <div className="input-field">
                  <input type="text" required="" id="value37" />
                  <label htmlFor="value37">Enter the value</label>
                </div>
                <div className="input-field mandate">
                  <input type="text" required="" id="value42" />
                  <label htmlFor="value42">Enter the value</label>
                </div>
                <div className="input-field baseline">
                  <input type="text" required="" id="value38" />
                  <label htmlFor="value38">Enter the value</label>
                </div>
              </div>
              <div className="carve-modal-footer">
                <div className="button-group">
                  <button className="carve-button-vice carve-button-block">save</button>
                  <button className="carve-button-main carve-button-block" onClick={() => closeModal('modalLg')}>cancel</button>
                </div>
              </div>
            </div>
          </div>
          <div className={`center-container ${lGshowScanning ? 'scanning' : ''}`}>

            <div className='snippet' ref={lGsnippetContainerRef}>
              <pre>
                <code>
                  <span className="cn">&lt;button</span>
                  <span className="cln"> class="</span><span className="cn">carve-button-vice</span><span className="cln">"</span><br />

                  &nbsp;&nbsp;<span className="cln"> data-modal="</span><span className="cn">modalLg</span><span className="cln">"</span><br />

                  &nbsp;&nbsp;<span className="cln"> onclick="</span>
                  <span className="cn">openModal('modalLg')</span>
                  <span className="cln">"</span><span className="cn">&gt;</span><br />

                  &nbsp;&nbsp;&nbsp;&nbsp;Open Large Modal<br />

                  <span className="cn">&lt;/button&gt;</span><br />

                  <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal split modal-large</span><span class="cln">"</span><span class="cn"> id="modalLg"&gt;</span><br />
                  &nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal-inner</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal-head</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">heading-medium</span><span class="cln">"</span><span class="cn">&gt;</span>card header<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;svg</span><span class="cln"> class="</span><span class="cn">icon icon-close</span><span class="cln">"</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;use</span><span class="cln">xlink:href="</span><span class="cn">#rsIconClose</span><span class="cln">" /&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/svg&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal-body</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">input-field</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;input</span><span class="cln">type="text"requiredid="value34"</span><span class="cn"> /&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;label</span><span class="cln"> for="value34"</span><span class="cn">&gt;</span>Enter the value<span class="cn">&lt;/label&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">input-field mandate</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;input</span><span class="cln">type="text"requiredid="value5"</span><span class="cn"> /&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;label</span><span class="cln"> for="value5"</span><span class="cn">&gt;</span>Enter the value<span class="cn">&lt;/label&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;p&gt;</span>Lorem ipsum dolor, sit amet consectetur adipiscing elit. Dolore quod maxime illo, veritatis ea quisquam voluptate. Corrupti, nisi reprehenderit rem dolorem rerum nulla obcaecati, quidem, deleniti deserunt itaque odit officia!<span class="cn">&lt;/p&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">bottom-line</span><span class="cln">"</span><span class="cn"> /&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-modal-footer</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">button-group</span><span class="cln">"</span><span class="cn">&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;button</span><span class="cln"> class="</span><span class="cn">button-vice button-block</span><span class="cln">"</span><span class="cn">&gt;</span>save<span class="cn">&lt;/button&gt;</span><br />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;button</span>
                  <span className="cln"> class="</span><span className="cn">carve-button-main carve-button-block</span><span className="cln">"</span><br />

                  &nbsp;&nbsp;<span className="cln"> data-modal="</span><span className="cn">modalLg</span><span className="cln">"</span><br />

                  &nbsp;&nbsp;<span className="cln"> onclick="</span>
                  <span className="cn">closeModal('modalLg')</span>
                  <span className="cln">"</span><span className="cn">&gt;</span><br />

                  &nbsp;&nbsp;&nbsp;&nbsp;cancel<br />

                  <span className="cn">&lt;/button&gt;</span><br />

                  &nbsp;&nbsp;&nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  &nbsp;&nbsp;<span class="cn">&lt;/div&gt;</span><br />
                  <span class="cn">&lt;/div&gt;</span><br />

                </code>
              </pre>
            </div>
            <button aria-label="Copy Button" onClick={lGcopySnippet}>
              <Copy />
            </button>

          </div>

        </section>


      </div>

    </motion.div>
  );
}

const ModalsCard = () => {
  return (
    <Card
      CardTitle='Modal'
      CardBody={<Modal />}
    />
  );
}

export default ModalsCard;